import { Pano } from "../display/Pano.js";
import { store } from "./DataManager.js";
import { VOMarker, VOVideo } from "./Structure.js";

export class AcfBridge {
    private _data: VOVideo;

    constructor(public pano: Pano) {
        var id = parseInt(pano.element.getAttribute("data-video"));
        this._data = { id: id };

        this.parse();

        var fields = acf.getFields(null);
        var ignoreChange: string[] = [
            // "marker_unity_default",
            // "marker_unity_active",
            "video_camera_x",
            "video_camera_y",
            "marker_x",
            "marker_y",
            "video_markers",
            "video_poster_desktop",
            "video_poster_mobile"
        ];

        for (var field of fields) {
            if (field.data.name && ignoreChange.indexOf(field.data.name) === -1)
                field.on("change", (fieldEvent: any) => this.onChange(fieldEvent));
        }
    }

    private onChange(fieldEvent: any): void {
        if (!store.data)
            return;
        this.parse();
        var key = fieldEvent.currentTarget.getAttribute("data-key");
        console.log("Field changed: ", acf.getField(key).data.name);
    }

    private parse(): void {
        var d = this._data;

        // d.is_panorama = Boolean(acf.getFields({ name: "video_is_panorama" })[0].val());
        d.video_desktop = { url: acf.getFields({ name: "video_video_desktop" })[0].$el.find("[data-name=filename]").attr("href") };
        if (!d.video_desktop.url)
            d.video_desktop = null;
        d.video_mobile = { url: acf.getFields({ name: "video_video_mobile" })[0].$el.find("[data-name=filename]").attr("href") };
        if (!d.video_mobile.url)
            d.video_mobile = null;
        d.video_desktop_de = { url: acf.getFields({ name: "video_video_desktop_de" })[0].$el.find("[data-name=filename]").attr("href") };
        if (!d.video_desktop_de.url)
            d.video_desktop_de = null;
        d.video_mobile_de = { url: acf.getFields({ name: "video_video_mobile_de" })[0].$el.find("[data-name=filename]").attr("href") };
        if (!d.video_mobile_de.url) {
            d.video_mobile_de = null;
        }

        d.icon = acf.getFields({ name: "video_icon" })[0].val() || "";
        d.next_video = acf.getFields({ name: "video_next_video" })[0].val();
        d.look_at = Boolean(acf.getFields({ name: "video_look_at" })[0].val());
        d.camera_x = parseFloat(acf.getFields({ name: "video_camera_x" })[0].val());
        d.camera_y = parseFloat(acf.getFields({ name: "video_camera_y" })[0].val());
        d.title_de = acf.getFields({ name: "video_title_de" })[0].val();
        d.title_en = acf.getFields({ name: "video_title_en" })[0].val();
        d.markers = [];

        var video_markers = acf.getFields({ name: "video_markers" })[0];
        for (var i = 0; i < video_markers.$rows().length; ++i) {
            var row = $(video_markers.$rows().get(i));

            var md: VOMarker = {};
            md.index = i;

            md.marker_label = acf.getFields({ name: "marker_label", parent: row })[0].val();
            md.marker_text = acf.getFields({ name: "marker_text", parent: row })[0].val();
            md.marker_label_de = acf.getFields({ name: "marker_label_de", parent: row })[0].val();
            md.marker_text_de = acf.getFields({ name: "marker_text_de", parent: row })[0].val();
            md.marker_action = acf.getFields({ name: "marker_action", parent: row })[0].val();
            // md.url = acf.getFields({ name: "marker_url", parent: row })[0].val();
            md.marker_video = acf.getFields({ name: "marker_video", parent: row })[0].val();
            md.marker_icon = acf.getFields({ name: "marker_icon", parent: row })[0].val();
            md.marker_x = parseFloat(acf.getFields({ name: "marker_x", parent: row })[0].val());
            md.marker_y = parseFloat(acf.getFields({ name: "marker_y", parent: row })[0].val());
            md.marker_start_time = parseFloat(acf.getFields({ name: "marker_start_time", parent: row })[0].val());
            md.marker_end_time = parseFloat(acf.getFields({ name: "marker_end_time", parent: row })[0].val());
            // md.unity_default = acf.getFields({ name: "marker_unity_default", parent: row })[0].val();
            // md.unity_active = acf.getFields({ name: "marker_unity_active", parent: row })[0].val();
            // this.setMarkerLabel(md);

            d.markers.push(md);
        }

        store.prepareVideo(d);

        this.pano.current = d;
    }

    public setMarkerPosition(index: number, x: number, y: number): void {
        this._data.markers[index].marker_x = x;
        this._data.markers[index].marker_y = y;
        var video_markers = acf.getFields({ name: "video_markers" })[0];
        var row = $(video_markers.$rows().get(index));
        acf.getFields({ name: "marker_x", parent: row })[0].val(x);
        acf.getFields({ name: "marker_y", parent: row })[0].val(y);
    }

    public setCameraLookAt(x: number, y: number): void {
        this._data.camera_x = x;
        this._data.camera_y = y;
        acf.getFields({ name: "video_camera_x" })[0].val(x);
        acf.getFields({ name: "video_camera_y" })[0].val(y);
    }

    private setMarkerLabel(marker: VOMarker) {
        var video_markers = acf.getFields({ name: "video_markers" })[0];
        var row = $(video_markers.$rows().get(marker.index));

        DrawHtml.draw(marker.marker_label, marker.marker_action == "text" ? DrawHtml.styleDefaultText : DrawHtml.styleDefault).then((can) => {
            acf.getFields({ name: "marker_unity_default", parent: row })[0].val(can.toDataURL().replace("data:image/png;base64,", ""));
        });

        if (marker.marker_action != "text") {
            DrawHtml.draw(marker.marker_label, DrawHtml.styleActive).then((can) => {
                acf.getFields({ name: "marker_unity_active", parent: row })[0].val(can.toDataURL().replace("data:image/png;base64,", ""));
            });
        } else {
            acf.getFields({ name: "marker_unity_active", parent: row })[0].val("");
        }
    }
}

export class DrawHtml {

    public static styleDefault = `
#text{
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(2, 2);
    display: inline-block;
    position: absolute;
    font-family: Arial, Helvetica, sans-serif;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    background-color: rgba(0, 0, 0, 0.7);
    font-family: Arial, Helvetica, sans-serif;
    border-radius: 3px;
    white-space: nowrap;
    border-bottom: 2px solid rgba(0, 171, 232, 0.85);
    color: #FFF;
    padding: 10px;
    text-transform: uppercase;
    box-sizing: content-box;
}
`;

    public static styleDefaultText = `
#text{
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(2, 2);
    display: inline-block;
    position: absolute;
    font-family: Arial, Helvetica, sans-serif;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    background-color: rgba(0, 0, 0, 0.7);
    font-family: Arial, Helvetica, sans-serif;
    border-radius: 3px;
    max-width: 180px;
    border-bottom: 2px solid rgba(0, 171, 232, 0.85);
    color: #FFF;
    padding: 10px;
    box-sizing: content-box;
}
`;

    public static styleActive = DrawHtml.styleDefault + `
#text{
    background-color: rgba(0, 171, 232, 0.85);
}
`;

    public static styleActiveText = DrawHtml.styleDefaultText + `
#text{
    background-color: rgba(0, 171, 232, 0.85);
}
`;

    public static draw(text: string, style: string): Promise<HTMLCanvasElement> {
        return new Promise<HTMLCanvasElement>(
            (resolve, reject) => {
                var width = 1024;
                var height = 512;
                const markup = `
                <div id='text'>$text</div>
                `;

                var data = '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + 'px">' +
                    '<style>' +
                    'foreignObject { overflow: visible; }' +
                    '#svg-text-holder { display:block; width: ' + width + 'px; height: ' + height + 'px; }' +
                    '</style>' +
                    '<foreignObject width="100%" height="100%">' +
                    '<style>' +
                    style +
                    '</style>' +
                    '<div xmlns="http://www.w3.org/1999/xhtml" id="svg-text-holder">' +
                    markup.replace("$text", text) +
                    '</div>' +
                    '</foreignObject>' +
                    '</svg>';

                var URL = window.URL;
                var svg = new Blob([data], { type: 'image/svg+xml;charset=utf-8' });
                var url = (<any>URL).createObjectURL(svg, { oneTimeOnly: true });

                url = 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent(data);

                var can = document.createElement("canvas");
                can.width = width;
                can.height = height;
                var ctx = can.getContext("2d");

                var img = new Image();
                img.onload = () => {
                    ctx.drawImage(img, 0, 0);

                    var data = ctx.getImageData(0, 0, width, height);

                    var minX = Number.MAX_VALUE;
                    var maxX = -Number.MAX_VALUE;
                    var minY = Number.MAX_VALUE;
                    var maxY = -Number.MAX_VALUE;

                    for (var i = 0; i < data.data.length; i += 4) {
                        var pi = i / 4;
                        var x = pi % width;
                        var y = Math.floor(pi / width);

                        if (data.data[i + 3] > 0) {
                            minX = Math.min(x, minX);
                            minY = Math.min(y, minY);
                            maxX = Math.max(x, maxX);
                            maxY = Math.max(y, maxY);
                        }
                    }

                    var margin = 2;
                    var bx = minX - margin;
                    var by = minY - margin;
                    var bw = (maxX - minX) + 2 * margin;
                    var bh = (maxY - minY) + 2 * margin;

                    var cans = document.createElement("canvas");
                    cans.width = bw;
                    cans.height = bh;
                    var c = cans.getContext("2d");

                    var d = ctx.getImageData(bx, by, bw, bh);
                    c.putImageData(d, 0, 0);

                    // cans.style.position = "fixed";
                    // cans.style.display = "block";
                    // cans.style.top = "100px";
                    // cans.style.left = "100px";
                    // cans.style.border = "1px solid #FF00FF";
                    // document.body.appendChild(cans);

                    resolve(cans);

                    // console.log(minX, minY, maxX - minX, maxY - minY);
                }
                img.src = url;

            }
        );
    }

    public static drawDep(element: HTMLElement): void {

        var width = element.offsetWidth;
        var height = element.offsetHeight;
        console.log(width, height);
        // setTimeout(() => {


        var elems: HTMLElement[] = [element];
        var list = element.getElementsByTagName("*");
        for (var i = 0; i < list.length; ++i)
            elems.push(list[i] as HTMLElement);
        var style = DrawHtml.getAllStyleRules(elems);

        var data = '<svg xmlns="http://www.w3.org/2000/svg">' +
            '<style>' +
            'foreignObject { overflow: visible; }' +
            '#svg-text-holder { display:inline-block; }' +
            '</style>' +
            '<foreignObject width="100%" height="100%">' +
            '<style>' +
            style +
            // ".marker-content>.marker-icon{display:none; }" +
            '</style>' +
            '<div xmlns="http://www.w3.org/1999/xhtml" id="svg-text-holder">' +
            element.outerHTML +
            '</div>' +
            '</foreignObject>' +
            '</svg>';

        var URL = window.URL;
        var svg = new Blob([data], { type: 'image/svg+xml;charset=utf-8' });
        var url = (<any>URL).createObjectURL(svg, { oneTimeOnly: true });

        url = 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent(data);

        var img = new Image();
        // var img = new Image(width, height);
        img.src = url;
        img.style.position = "fixed";
        img.style.display = "block";
        img.style.top = "100px";
        img.style.left = "100px";
        document.body.appendChild(img);
    }

    private static getAllStyleRules(elems: HTMLElement[]): string {
        var rules: CSSStyleRule[] = [];
        var style = "";
        var l = document.styleSheets.length;
        for (var i = 0; i < l; ++i) {
            var ss = <CSSStyleSheet>document.styleSheets.item(i);
            for (var j = 0; j < ss.cssRules.length; ++j) {
                var rule = <CSSStyleRule>ss.cssRules.item(j);
                for (var elem of elems) {
                    if (rule.selectorText) {

                        var st = rule.selectorText.replace("::before", "");
                        if (elem.matches(st)) {
                            rules.push(rule);
                            // if (rule.selectorText.indexOf("::before") != -1) {
                            //     // console.log("AHHH", rule.style.content.charCodeAt(1));
                            //     var charCode = rule.style.content.charCodeAt(1);
                            //     var newCont = "content:\"" + String.fromCharCode(charCode) + "\"";
                            //     newCont = "content:\"\\ec2b\"";
                            //     newCont = "content:\"&#xec2b\"";
                            //     newCont = "content:\"&#EC2B\"";
                            //     newCont = "content:\"\\&#EC2B\"";
                            //     style += rule.cssText.replace(/content.*\:.*\".*\"/gi, newCont);
                            // }
                            // else {
                            style += rule.cssText;
                            // }
                            break;
                        }
                    }
                }
            }
        }
        return style;
        // for(var ss of document.styleSheets[0])
    }

    // private static getAllStyles(elem: HTMLElement) {
    //     if (!elem) return []; // Element does not exist, empty list.
    //     var win = document.defaultView || window, style, styleNode = [];
    //     if (win.getComputedStyle) { /* Modern browsers */
    //         style = win.getComputedStyle(elem, '');
    //         for (var i = 0; i < style.length; i++) {
    //             styleNode.push(style[i] + ':' + style.getPropertyValue(style[i]));
    //             //               ^name ^           ^ value ^
    //         }
    //     } else if (elem.currentStyle) { /* IE */
    //         style = elem.currentStyle;
    //         for (var name in style) {
    //             styleNode.push(name + ':' + style[name]);
    //         }
    //     } else { /* Ancient browser..*/
    //         style = elem.style;
    //         for (var i = 0; i < style.length; i++) {
    //             styleNode.push(style[i] + ':' + style[style[i]]);
    //         }
    //     }
    //     return styleNode;
    // }
}